function getBaseUrl(hostName) {
  switch (hostName) {
    case "localhost":
      // return "https://thriftstorenepal.techeverestnepal.com/api/";
      return "https://api.thriftshopnepal.com/api/";
    case "staging":
      return "https://thriftstorenepal.techeverestnepal.com/api/";
    case "www.staging":
      return "https://thriftstorenepal.techeverestnepal.com/api/";
    case "prod":
      return "https://api.thriftshopnepal.com/api/";
    default:
      return "https://api.thriftshopnepal.com/api/";
  }
}

export const baseUrl = getBaseUrl(window.location.hostname.split(".")[0]);

export function checkEnvironment(
  hostName = window.location.hostname.split(".")[0]
) {
  switch (hostName) {
    case "localhost":
      return "prod";
    case "staging":
      return "staging";
    case "prod":
      return "prod";
    case "www":
      const hostName = window.location.hostname.split(".")[1];
      return getBaseUrl(hostName);
    default:
      return "prod";
  }
}
